<script>
import { mapGetters } from 'vuex';
import { filter, get, orderBy } from 'lodash';
import qs from 'query-string';
import { translation, translateToEn } from '@/plugins/i18n';
import { BASE_PLAN_SUB_TYPES, planTypes } from '@/common/constants';
import base from '@/views/config/addon-cards/templates/base.vue';
import logo from '@/assets/plans/zoom_one_pro_addon.svg';
import {
  ProPlanSwitchSupportedPlanTypes,
} from '@/plans/ZOOM_MEETING/common/utils';
import { getRecommendPlansFrom } from '@/common/product';
import { updateHrefWithQueryParams } from '@/utils';
import { AddOnGroupTrackingUILocation, getTrackingFlowType } from '@/aspects/trackings';

const addOnMeetingMap = () => {
  return {
    [BASE_PLAN_SUB_TYPES.PRO]: {
      title: translation('billing.planform.title.zoom_one_pro'),
      trackingPlanName: translateToEn('billing.planform.title.zoom_one_pro'),
      description: translation('billing.zoom_one_pro.desc'),
      category: BASE_PLAN_SUB_TYPES.PRO,
      buyLink: '/opc/buy?plan=pro&period=annual&from=pro&usageType=business',
    },
    [BASE_PLAN_SUB_TYPES.BIZ]: {
      title: translation('billing.planform.title.zoom_one_biz'),
      trackingPlanName: translateToEn('billing.planform.title.zoom_one_biz'),
      description: translation('billing.zoom_one_pro.desc'),
      category: BASE_PLAN_SUB_TYPES.BIZ,
      buyLink: '/opc/buy?plan=biz&period=annual&from=biz&usageType=business',
    },
  };
};

export default {
  name: 'ZoomMeetingAddOnCard',
  mixins: [base],
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [
      this.$money(amount),
    ]);
    const dataKeys = ['title', 'trackingPlanName', 'description', 'category'];
    dataKeys.forEach((key) => {
      this[key] = this.currentPlan[key];
    });
    this.updateDescription();

    this.productPlans = this.currentProductPlans;
  },
  data() {
    return {
      logo,
      subtitle: '',
      planType: planTypes.ZOOM_MEETING,
      addText: this.$t('common.btn_switch_plan'),
      addTrackingText: translateToEn('common.btn_switch_plan'),
      hideLearnMoreDialogOptions: true,
    };
  },
  computed: {
    ...mapGetters(['planMapFlat', 'getSelectedPlans', 'couponState']),
    currentSelectedBasePlan() {
      return get(getRecommendPlansFrom(this.getSelectedPlans), [0], {});
    },
    subType() {
      return ProPlanSwitchSupportedPlanTypes.includes(
        this.currentSelectedBasePlan.type,
      )
        ? BASE_PLAN_SUB_TYPES.PRO
        : BASE_PLAN_SUB_TYPES.BIZ;
    },
    currentPlan() {
      return addOnMeetingMap()[this.subType];
    },
    currentProductPlans() {
      return orderBy(
        filter(
          this.planMapFlat,
          (p) =>
            p.type === planTypes.ZOOM_MEETING &&
            p.category === this.subType &&
            !p.isOneMonth,
        ),
        ['participants', 'amount'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
  methods: {
    updateDescription() {
      const descriptionMap = {
        [planTypes.ZOOM_DOCS]: this.$t('billing.zoom_one_pro.desc_used_as_addon_for_docs'),
        [planTypes.ZOOM_SCHEDULER]: this.$t('billing.zoom_one_biz.desc_used_as_addon_for_scheduler'),
        [planTypes.ZOOM_WHITEBOARD]: this.$t('billing.zoom_one_biz.desc_used_as_addon_for_whiteboard'),
      }
      const desc = descriptionMap[this.currentSelectedBasePlan.type];
      if (desc) {
        this.description = desc;
      }
    },
    addOn() {
      this.$tracking({
        event: 'buyInteraction',
        buyInteraction: `${this.trackingBasePlanName} add-ons`,
        buySelection: `${this.trackingPlanName} - ${this.trackingAddAction}`,
        uiLocation: AddOnGroupTrackingUILocation[this.group],
        flowType: getTrackingFlowType()
      })
      const cacheTimestamp = qs.parse(location.search)._;
      const params = {
        switchFrom: `${this.currentSelectedBasePlan.plan_code},${cacheTimestamp}`,
      }
      if (this.couponState.couponCode) {
        params.persistCoupon = this.couponState.couponCode;
      }
      location.replace(
        updateHrefWithQueryParams(
          this.currentPlan.buyLink,
          ['type', 'pageType'],
          params,
        ),
      );
    },
  },
};
</script>
